import React, { FC } from 'react';
import { Trans } from '@lingui/react';

import { RoverBHLogos } from '@rover/icons';
import { Button, Flex, Link } from '@rover/kibble/core';
import { MQ } from '@rover/kibble/styles';
import useMatchMedia from '@rover/react-lib/src/hooks/useMatchMedia';
import { CountryConfiguration } from '@rover/rsdk/src/apiClient/latest';
import useCountryConfigurationShim from '@rover/shared/js/hooks/useCountryConfigurationShim';
import useCurrentUserShim from '@rover/shared/js/hooks/useCurrentUserShim';
import type { Props } from '@rover/shared/js/ssr/BaseTemplate/NavBar/NavBarRight';
import NavBarRight from '@rover/shared/js/ssr/BaseTemplate/NavBar/NavBarRight';

const getHomepageHrefForCountryConfig = (cc: CountryConfiguration | null): string => {
  const { urlPrefix } = cc ?? {};
  if (!urlPrefix) return '/';
  return `/${urlPrefix}/`;
};

const NavbarLeft = (): JSX.Element => {
  const isMobile = useMatchMedia(MQ.MOBILE.getBreakpointString());
  const { current: cc = null, navigation: nc = null } = useCountryConfigurationShim();
  const countryConfig: CountryConfiguration | null = nc ?? cc;
  return (
    <Flex alignItems="flex-start" gap="4x">
      <Link href={getHomepageHrefForCountryConfig(countryConfig)} aria-label="Rover.com">
        <RoverBHLogos />
      </Link>
      {!isMobile && (
        <Button variant="default" size="small" href="/bright-horizons">
          <Trans id="Back-Up Care credits" />
        </Button>
      )}
    </Flex>
  );
};

const Navbar: FC<Props> = ({ onToggleMobileMenu, isMobileMenuOpen }) => {
  const { user } = useCurrentUserShim();
  const isStamped = user?.isBrightHorizonsUser ?? false;
  if (isStamped) {
    return (
      <Flex justifyContent="space-between" alignItems="center" minHeight="60px">
        <NavbarLeft />
        <NavBarRight onToggleMobileMenu={onToggleMobileMenu} isMobileMenuOpen={isMobileMenuOpen} />
      </Flex>
    );
  }
  return (
    <Flex justifyContent="center" alignItems="center" minHeight="60px">
      <RoverBHLogos />
    </Flex>
  );
};

export default Navbar;
